import * as React from 'react';

import styles from './styles.module.scss';

export const Text = ({ ...other }) => (
  <p className={styles.field_text} {...other} />
);

export default Text;
